import { useRoutes } from 'react-router-dom';
// import AppRoutes from './AppRoutes';
import MainRoutes from './MainRoutes.js';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([MainRoutes]);
}
